import styled from 'styled-components';
import { getStreakInfo, streakIcon, StreakInfoProps, StreakType, streakType } from '../StreakInfo/StreakLogic';
import SvgIcon from '../SvgIcon';
import ReactTooltip from 'react-tooltip';
import * as React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

const NavbarStreakContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-right: 20px;
`;

const NavbarText = styled.span`
  color: ${p => p.theme.color.black2};
  padding-left: 5px;
`;

const StreakNavItem = (props: StreakInfoProps) => {
  const type = streakType(props);
  const messageBase = 'components.StreakNavbar';

  let tipMessage = <FormattedMessage id={`${messageBase}.tooltip`} />;
  if (props.current > 2 && props.current >= props.longest) {
    tipMessage = <FormattedMessage id={`${messageBase}.tooltip_longest`} />;
  }

  const shouldShow = props.current > 0 && props.longest > 0;

  if (shouldShow) {
    return (
      <NavbarStreakContainer data-tip={true} data-for="streak-info">
        {type !== StreakType.none && <SvgIcon iconName={streakIcon(type)} iconWidth={'20px'} iconHeight={'20px'} />}
        <NavbarText>{props.current}</NavbarText>
        <ReactTooltip id="streak-info" effect="solid">
          <span>{tipMessage}</span>
        </ReactTooltip>
      </NavbarStreakContainer>
    );
  } else {
    return null;
  }
};

export default React.memo(
  connect((state, props) => {
    return {
      ...getStreakInfo(state),
      ...props,
    };
  })(StreakNavItem),
);



// WEBPACK FOOTER //
// ./src/components/StreakNavbar/index.tsx